import { ApiError, errorMessage } from '../api/client';

// MutationError zeigt Fehler von Speichervorgängen inklusive Feldhinweisen des Servers.
export function MutationError({ error }: { error: unknown }) {
  const fields = error instanceof ApiError ? error.fieldErrors : [];
  return (
    <div className="alert alert-error" role="alert">
      {fields.length > 0 ? (
        <ul className="plain-list">
          {fields.map((f) => (
            <li key={`${f.field}-${f.code}`}>{f.message}</li>
          ))}
        </ul>
      ) : (
        errorMessage(error)
      )}
    </div>
  );
}
